module.exports = __webpack_public_path__ + "img/1-low.754477e0.jpg";